import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';

const Wrap = styled.div`
	position: relative;
	${rmq('mm')} {
		padding: 0 1rem;
	}
`;
const Button = styled.a`
	display: table;
	width: 100%;
	max-width: 35rem;
	min-width: 15rem;
	padding: 1.6rem;
	margin: 5rem auto;
	font-family: ${props => props.theme.f2};
	font-size: 2rem;
	font-weight: 900;
	color: ${props => props.theme.c1};
	background: ${props => props.theme.gr5};
	box-shadow: rgba(101, 41, 255, 0.15) 0px 10px 20px;
	border-radius: 30px;
	text-decoration: none;
	transition: box-shadow 0.8s cubic-bezier(0.2, 0.8, 0.2, 1.2) 0s, transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1.2) 0s;
	transition: all 0.4s ease;
	position: relative;
	text-align: center;
	cursor: pointer;

	${rmq('mm')} {
		font-size: 1.8rem;
	}

	&:hover {
		transition: all 0.4s ease;
		box-shadow: 0 0 12rem 0 rgba(22, 22, 22, 0.5);
	}
`;

export default props => (
	<Wrap>
		<Button {...props}>{props.children}</Button>
	</Wrap>
);
